import React from 'react';
import { Button, Modal } from '@ver-uds/react';
import { Alert, ButtonGroup } from '@ver-uds/uswds-react';
import { AccountStatus } from 'eve-account-client';
import ErrorConstants from '../../constants/ErrorConstants';
import SuccessConstants from '../../constants/SuccessConstants';
import { AlertType, ResendMouEmailModalData } from './ManageCompaniesResultsModalData';

export interface ResendMouEmailModalProps {
  open: boolean;
  modalData?: ResendMouEmailModalData;
  modalAlert?: AlertType;
  onClose: () => void;
  onSubmit: () => void;
}

export const ResendMouEmailModal = ({
  open,
  modalData,
  modalAlert,
  onClose,
  onSubmit,
}: ResendMouEmailModalProps): JSX.Element => {
  const generateModalText = () => {
    if (modalData?.status === AccountStatus.PENDING) {
      return `Are you sure you want to resend the MOU Signatory email to ${modalData.companyName}?`;
    }
    if (modalData?.status === AccountStatus.REJECTED) {
      return `Click the "Resend MOU Email" button to resend the MOU Signatory email to ${modalData.companyName}. The client's status will be set to "Pending".`;
    }
    return '';
  };

  const renderModalContent = (): JSX.Element => {
    return (
      <>
        <Modal.Content>
          <p>{generateModalText()}</p>
        </Modal.Content>
        <Modal.Footer className="display-flex flex-row flex-justify-end">
          <ButtonGroup>
            <Button variant="secondary" type="button" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="primary" type="button" onClick={onSubmit}>
              Resend MOU Email
            </Button>
          </ButtonGroup>
        </Modal.Footer>
      </>
    );
  };

  const renderModalAlert = (): JSX.Element => {
    switch (modalAlert) {
      case AlertType.ERROR:
        return (
          <Alert status="error" slim>
            <Alert.Text>{ErrorConstants.RESEND_MOU_EMAIL_ERROR}</Alert.Text>
          </Alert>
        );
      case AlertType.SUCCESS:
        return (
          <Alert status="success" slim>
            <Alert.Text>{SuccessConstants.RESEND_MOU_EMAIL_SUCCESS}</Alert.Text>
          </Alert>
        );
      default:
        return <></>;
    }
  };

  return (
    <Modal header="Resend MOU Signatory Email" id="resend-mou-email-modal" open={open} close={onClose}>
      {modalAlert !== undefined ? renderModalAlert() : renderModalContent()}
    </Modal>
  );
};

export default ResendMouEmailModal;
